import Vue from 'vue'
import App from './App.vue'
import router from '@/libs/router.js'
import store from './store'
import request from '@/libs/request.js'
import '@/assets/css/style.css'
import '@/assets/css/xixi.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

//使用vue-meta
import VueMeta from 'vue-meta';

Vue.use(VueMeta);

// 使用swiper插件
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
//全局请求
Vue.prototype.$request = request

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
